// extracted by mini-css-extract-plugin
export default {"contato":"Contato_contato__TD2E3","dados":"Contato_dados__Qybky"};